import React from 'react'

import styled, { withTheme } from 'styled-components'

import Icon from 'components/icons'

import { EditLegWrapper, EditLegLabel } from '../styled'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const EditLegLink = ({ onEditLeg, label, iconName, name, isResearch, theme, index }) => (
  <EditLegWrapper onClick={onEditLeg} name={name} isResearch={isResearch} index={index}>
    <StyledContainer
      tabIndex={0}
      onKeyDown={e => {
        if (e.key == 'Enter') {
          e.preventDefault()
          onEditLeg()
        }
      }}
    >
      <Icon name={iconName} size={20} color={theme.colors.blue} />
      <EditLegLabel>{label}</EditLegLabel>
    </StyledContainer>
  </EditLegWrapper>
)

export default withTheme(EditLegLink)
